import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `@@pt-audit.rpc`,
    services: {
        quiz: {
            parameters: []
        },
        info: {
            parameters: []
        },
        start_quiz: {
            parameters: []
        },
        finish_quiz: {
            parameters: []
        },
        get_questions: {
            parameters: [
                {
                    name: 'qrlocator',
                    type: 'object',
                    optional: true
                },
                {
                    name: 'select',
                    type: 'object',
                    optional: true
                }
            ]
        }
    }
});
export default svc;
